import * as React from 'react';

import classNames from 'classnames';

import styles from './FreeTrialBanner.module.scss';

export interface FreeTrialBannerProps {
  freeTrialDaysLeft: number;
  isPermanent?: boolean;
}

export const FreeTrialBanner: React.FC<FreeTrialBannerProps> = ({
  freeTrialDaysLeft,
  isPermanent,
}) => {
  return (
    <>
      {isPermanent ? (
        <div className={styles['free-trial-banner']}>
          <span>Permanent Trial</span>
        </div>
      ) : (
        <div
          className={classNames([
            styles['free-trial-banner'],
            freeTrialDaysLeft <= 0 && styles['expiring-soon'],
          ])}
        >
          <span>Free Trial</span>
          {freeTrialDaysLeft > 0 && (
            <span>{`${freeTrialDaysLeft} day${
              freeTrialDaysLeft === 1 ? '' : 's'
            } left`}</span>
          )}
          {freeTrialDaysLeft === 0 && <span>Expires Today</span>}
          {freeTrialDaysLeft < 0 && <span>Expired</span>}
        </div>
      )}
    </>
  );
};
